import VacancySettingsBanner from './VacancySettingsBanner.component';

export default VacancySettingsBanner;